<template>
    <div class="searchCon">
        <div>{{ title }}</div>
        <ul>
            <li v-for="(item, index) in bookList" :key="index" class="bookList_book_style" @click="goBook(item.id)" :title="item.name">
                <dl>
                    <dt>
                        <img :src="item.cover" alt="">
                        <div>
                            <div></div>
                            <p>{{ item.plays }}</p>
                        </div>
                    </dt>
                    <dd>
                        <p>{{ item.name }}</p>
                        <p>{{ item.author }}</p>
                    </dd>
                </dl>
            </li>
        </ul>
        <pager :total-page="totalPage" :initPage="pageNum" @go-page="goPageNum" v-if="isShowPager" />
    </div>
</template>

<script>
import pager from './pager.vue'
export default {
    components: {
        pager
    },
    data() {
        return {
            title: "为您搜索到以下内容：",
            bookList: [],
            totalPage: 1,
            pageNum: 1,
            isShowPager: false,
        }
    },
    computed: {
        searchVal() {
            return this.$store.state.searchVal;
        }
    },
    mounted() {
        let that = this;
        that.searchBook();
    },
    destroyed() {
        let that = this;
        sessionStorage.removeItem("searchVal");
        that.$store.commit("setSearchVal", "")
    },
    methods: {
        searchBook() {
            let that = this;
            let data = {
                search: {
                    search: that.searchVal
                },
                page: that.pageNum,
                size: 30
            }
            that.allApi.searchList(data).then((resource) => {
                // console.log(resource.data);
                if( resource.data.code == 200 ) {
                    that.bookList = resource.data.data.list;
                    if( that.bookList.length != 0 ) {
                        that.title = "为您搜索到以下内容：";
                    }else {
                        that.title = "很遗憾！未搜索到您想要的内容......";
                    }
                    that.totalPage = resource.data.data.pages;
                }
            })
        },
        goPageNum(obj) {
            let that = this;
            that.pageNum = obj.page;
            that.searchBook();
        },
        goBook(bookId) {
            let that = this;
            that.addClickNum(bookId);
            that.$router.push({
                path: '/book',
                query: {
                    id: bookId
                }
            })
        },
        addClickNum(bookId) {
            let that = this;
            let data = {
                book: bookId
            }
            that.allApi.bookClick(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    
                }
            })
        }
    },
    watch: {
        searchVal() {
            let that = this;
            that.pageNum = 1;
            that.searchBook();
        },
        totalPage(newV) {
            let that = this;
            if( newV == 1 ) {
                that.isShowPager = false;
            }else{
                that.isShowPager = true;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .searchCon{
        width: 1200px;
        margin: 0 auto;
        >div:first-of-type{
            padding: 0 30px;
            line-height: 74px;
            font-size: 20px;
            @include dominant_color(#1c1c1c);
            background: #F7F7F7;
            margin-bottom: 40px;
        }
        >ul{
            display: flex;
            flex-wrap: wrap;
            >li{
                margin-bottom: 50px;
                margin-right: 66px;
                width: 145px;
                
                &:nth-child(6n) {
                    margin-right: 0;
                }
            }
        }
    }
</style>
